export const STATUS_COLORS = {
  // Trạng thái chờ xử lý (màu vàng)
  "Chờ duyệt": "bg-yellow-500",
  "Chờ xử lý": "bg-yellow-500",

  // Trạng thái đang xử lý (màu xanh dương)
  "Đang triển khai": "bg-blue-500",
  "Đang xử lý": "bg-blue-500",

  // Trạng thái hoàn thành (màu xanh lá)
  "Đã hoàn thành": "bg-green-600",
  "Đã duyệt": "bg-green-600",
  "Đã thanh toán": "bg-green-600",

  // Trạng thái tạm dừng / từ chối
  "Tạm ngưng": "bg-gray-500",
  "Từ chối": "bg-red-500",

  // Trạng thái tài chính
  "Chưa thanh toán": "bg-red-500",
};

export const STATUS_BADGE_COLORS = {
  // Trạng thái chờ xử lý
  "Chờ duyệt": "bg-yellow-100 text-yellow-700 border border-yellow-300",
  "Chờ xử lý": "bg-yellow-100 text-yellow-700 border border-yellow-300",

  // Trạng thái đang xử lý
  "Đang triển khai": "bg-blue-100 text-blue-700 border border-blue-300",
  "Đang xử lý": "bg-blue-100 text-blue-700 border border-blue-300",

  // Trạng thái hoàn thành
  "Đã hoàn thành": "bg-green-100 text-green-700 border border-green-300",
  "Đã duyệt": "bg-blue-100 text-blue-700 border border-blue-300",

  // Trạng thái tạm dừng / từ chối
  "Tạm ngưng": "bg-gray-100 text-gray-700 border border-gray-300",
  "Từ chối": "bg-red-100 text-red-700 border border-red-300",
  "Đã hủy": "bg-red-100 text-red-700 border border-red-300",

  // Trạng thái tài chính
  "Chưa thanh toán": "bg-red-50 text-red-600 border border-red-300",
  "Chưa duyệt": "bg-red-50 text-red-600 border border-red-300",

  // Trạng thái Đang hoạt động
  "Đang hoạt động": "bg-green-50 text-green-600 border border-green-300",
  "Hoạt động": "bg-green-50 text-green-600 border border-green-300",
  "Đã thanh toán": "bg-green-50 text-green-600 border border-green-300",

  // Trạng thái Không hoạt động
  "Không hoạt động": "bg-red-50 text-red-600 border border-red-300",
  "Ngưng hoạt động": "bg-red-50 text-red-600 border border-red-300",
  "Ngừng hoạt động": "bg-red-50 text-red-600 border border-red-300",
  "Tạm dừng": "bg-red-50 text-red-600 border border-red-300",
  "Ngưng dùng": "bg-red-50 text-red-600 border border-red-300",
  "Đang dùng": "bg-green-50 text-green-600 border border-green-300",

  // Ticket
  "Chờ phản hồi": "bg-orange-100 text-orange-700 border border-orange-300",
  // "Đang xử lý": "bg-blue-100 text-blue-700 border border-blue-300",
  "Đã hoàn thiện": "bg-green-100 text-green-700 border border-green-300",
};

export const getStatusColor = (status, defaultColor = "bg-gray-400") => {
  return STATUS_COLORS[status] || defaultColor;
};

export const getStatusBadgeColor = (
  status,
  defaultColor = "bg-gray-100 text-gray-700 border border-gray-300",
) => {
  return STATUS_BADGE_COLORS[status] || defaultColor;
};

export const StatusBadge = ({ status, className = "" }) => {
  const colorClass = getStatusBadgeColor(status);

  return (
    <span
      className={`w-fit-content px-3 py-1 rounded-full text-center text-xs font-medium ${colorClass} ${className}`}
    >
      {status}
    </span>
  );
};
